/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

/**
 * Maps the `screen` query param from the deep link URL to the Peazy mobile app's
 * custom URL scheme path.
 *
 * URL format: https://web.peazy.com/open/peazy?screen=<key>&id=<entityId>
 * Mobile scheme: ark://<path>?id=<entityId>
 *
 * Add new entries here to support additional routes without a new app release (AC6).
 */
export const DEEP_LINK_ROUTE_MAP: Record<string, string> = {
  roster: 'roster',
  job: 'job',
  profile: 'profile',
  home: 'home',
  facility: 'facility',
  schedule: 'schedule',
  shift: 'shift',
};

export const PEAZY_APP_SCHEME = 'ark://';

export const PEAZY_IOS_STORE_URL = 'https://apps.apple.com/app/id6443427715';

export const PEAZY_ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.abil.peazyApp';

/** Milliseconds to wait for the native app to open before falling back to the store. */
export const STORE_FALLBACK_DELAY_MS = 5000;
